import Axios from 'axios';
import { getHeaders } from '../../utills';
import Apis from '../Apis';
import StoreAction from '../Actions/StoreAction';
import GeneralAction from '../Actions/GeneralAction';
import SubscriptionActions from '../Actions/SubscriptionActions';
import AuthAction from '../Actions/AuthActions';
import AlertAction from '../Actions/AlertActions';

class SubscriptionMiddlewre {
  static getSubscription = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(
            Apis.getSubscriptionPackages,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getSubscriptionHistory = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.next_page_url == undefined) {
            dispatch(SubscriptionActions.clearSubscriptionHistory());
          }
          const { data } = await Axios.get(
            Apis.getSubscriptionHistory(userData?.next_page_url),
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            console.log('first', data?.data);
            dispatch(SubscriptionActions.getSubscriptionHistory(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };


  static getPayNow = (userData) => {
    console.log(userData)
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const formData = new FormData();
          formData.append('payment_method_id', userData?.payment_method_id)
          formData.append('plan_id', userData?.plan_id)
          const { data } = await Axios.post(
            Apis.subscribe,
            formData,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            localStorage.setItem('@user', JSON.stringify(userData?.user));
            dispatch(AuthAction.getUser(userData?.user));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
          }
        } catch (error) {
          reject(error);
          console.log(error.message);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          dispatch(GeneralAction.HideLoading());
        }
      })
    }
  };
  static subscribeInApp = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const formData = new FormData();
          formData.append('plan_id', userData?.productId)
          const { data } = await Axios.post(
            Apis.subscribeInApp,
            formData,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            localStorage.setItem('@user', JSON.stringify(data?.data));
            dispatch(AuthAction.getUser(data.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          console.log(error.message);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          dispatch(GeneralAction.HideLoading());
        }
      })
    }
  }
}

export default SubscriptionMiddlewre;
